import axios from 'axios'

function getClientSession() {
  return axios
    .post(
      'api/client_sessions',
      {
        key: process.env.IDENTITY_KEY,
        secret: process.env.IDENTITY_SECRET
      },
      {
        baseURL: `${process.env.IDENTITY_URL}/chatbot`,
        headers: {
          'Content-Type': 'application/json'
        }
      }
    )
    .then((res) => res.data)
}

export default {
  getClientSession
}
